const SOURCE_TYPE_WAREHOUSE = 1;
const SOURCE_TYPE_BRANCH = 2;
const SOURCE_TYPE_SUPPLIER = 3;
const UNIT_COST_CURRENT = 2;
const GET_ALL = 1;
const GET_LOW_ON_STOCK = 2;
const GET_EXCEEDED_HIGH_STOCK = 3;
const GET_HIDDEN_ITEMS = 4;
const STATUS_VOID = -1;
const STATUS_PENDING = 0;
const STATUS_COMPLETED = 1;
const STATUS_IN_TRANSIT = 2;
const STOCK_TRANSFER = 0;
const STOCK_IN = 1;
const STOCK_OUT = 2;
const STOCK_ADJUSTMENT = 7;

export {
  SOURCE_TYPE_WAREHOUSE,
  SOURCE_TYPE_BRANCH,
  SOURCE_TYPE_SUPPLIER,
  UNIT_COST_CURRENT,
  GET_ALL,
  GET_LOW_ON_STOCK,
  GET_EXCEEDED_HIGH_STOCK,
  GET_HIDDEN_ITEMS,
  STATUS_VOID,
  STATUS_PENDING,
  STATUS_COMPLETED,
  STATUS_IN_TRANSIT,
  STOCK_TRANSFER,
  STOCK_IN,
  STOCK_OUT,
  STOCK_ADJUSTMENT,
};
